<template>
<div>
    <div class="">

        <div class="">
            <div class="row">
                <div class="col">
                    <h5>Filter Token</h5>
                    <b-form-input v-model="searchText" placeholder="Search by name" @input="currentPage=1"></b-form-input>
                </div>
                <div class="text-right col">
                    Rates Powered By <a href="https://lulo.fi?utm_source=Solana+Compass&utm_campaign=Solana+Compass" _target="blank">
                    <svg viewBox="0 0 63 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-10"><path d="M4.9734 9.7729H13.4892V14.0209H0.160156V0.504613H4.9734V9.7729ZM30.3355 7.24343C30.3355 11.9355 27.8733 14.214 22.19 14.214C16.4882 14.214 14.0445 11.9548 14.0445 7.24343V0.504613H18.8577V7.24343C18.8577 8.6916 19.3576 9.966 22.19 9.966C25.0223 9.966 25.5222 8.67229 25.5222 7.24343V0.504613H30.3355V7.24343ZM35.8877 9.7729H44.4035V14.0209H31.0745V0.504613H35.8877V9.7729ZM52.9192 14.214C47.2173 14.214 44.7737 11.9548 44.7737 7.24343C44.7737 2.55135 47.2173 0.311523 52.9192 0.311523C58.6025 0.311523 61.0646 2.57067 61.0646 7.24343C61.0646 11.9355 58.6025 14.214 52.9192 14.214ZM52.9192 9.966C55.7516 9.966 56.2515 8.67229 56.2515 7.24343C56.2515 5.83387 55.77 4.55949 52.9192 4.55949C50.0683 4.55949 49.5869 5.81458 49.5869 7.24343C49.5869 8.6916 50.0867 9.966 52.9192 9.966Z" fill="#00F08B"></path><mask id="mask0_112_15" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="62" height="15"><path d="M61.2857 0.0146484H0V14.468H61.2857V0.0146484Z" fill="white"></path><path d="M4.9734 9.77315H13.4892V14.0211H0.160156V0.504857H4.9734V9.77315ZM30.3355 7.24368C30.3355 11.9358 27.8733 14.2142 22.19 14.2142C16.4882 14.2142 14.0445 11.955 14.0445 7.24368V0.504857H18.8577V7.24368C18.8577 8.69184 19.3576 9.96624 22.19 9.96624C25.0223 9.96624 25.5222 8.67253 25.5222 7.24368V0.504857H30.3355V7.24368ZM35.8877 9.77315H44.4035V14.0211H31.0745V0.504857H35.8877V9.77315ZM52.9192 14.2142C47.2173 14.2142 44.7737 11.955 44.7737 7.24368C44.7737 2.5516 47.2173 0.311768 52.9192 0.311768C58.6025 0.311768 61.0646 2.57091 61.0646 7.24368C61.0646 11.9358 58.6025 14.2142 52.9192 14.2142ZM52.9192 9.96624C55.7516 9.96624 56.2515 8.67253 56.2515 7.24368C56.2515 5.83412 55.77 4.55973 52.9192 4.55973C50.0683 4.55973 49.5869 5.81482 49.5869 7.24368C49.5869 8.69184 50.0867 9.96624 52.9192 9.96624Z" fill="black"></path></mask><g mask="url(#mask0_112_15)"><path d="M4.97319 9.77298H4.83033V9.92198H4.97319V9.77298ZM13.489 9.77298H13.6318V9.62397H13.489V9.77298ZM13.489 14.0209V14.17H13.6318V14.0209H13.489ZM0.159948 14.0209H0.0170898V14.17H0.159948V14.0209ZM0.159948 0.50469V0.355687H0.0170898V0.50469H0.159948ZM4.97319 0.50469H5.11605V0.355687H4.97319V0.50469ZM4.97319 9.92198H13.489V9.62397H4.97319V9.92198ZM13.3461 9.77298V14.0209H13.6318V9.77298H13.3461ZM13.489 13.8719H0.159948V14.17H13.489V13.8719ZM0.302805 14.0209V0.50469H0.0170898V14.0209H0.302805ZM0.159948 0.653694H4.97319V0.355687H0.159948V0.653694ZM4.83033 0.50469V9.77298H5.11605V0.50469H4.83033ZM14.0442 0.50469V0.355687H13.9014V0.50469H14.0442ZM18.8575 0.50469H19.0004V0.355687H18.8575V0.50469ZM25.522 0.50469V0.355687H25.3791V0.50469H25.522ZM30.3352 0.50469H30.4781V0.355687H30.3352V0.50469ZM30.1924 7.24351C30.1924 9.56255 29.5848 11.2556 28.3021 12.374C27.0138 13.4973 25.0177 14.065 22.1898 14.065V14.3631C25.0451 14.3631 27.1218 13.7915 28.4854 12.6026C29.8545 11.4088 30.4781 9.61654 30.4781 7.24351H30.1924ZM22.1898 14.065C19.3522 14.065 17.3562 13.502 16.0704 12.3812C14.7904 11.2654 14.1871 9.57269 14.1871 7.24351H13.9014C13.9014 9.6257 14.5201 11.4182 15.8872 12.6099C17.2487 13.7965 19.3255 14.3631 22.1898 14.3631V14.065ZM14.1871 7.24351V0.50469H13.9014V7.24351H14.1871ZM14.0442 0.653694H18.8575V0.355687H14.0442V0.653694ZM18.7147 0.50469V7.24351H19.0004V0.50469H18.7147ZM18.7147 7.24351C18.7147 7.98127 18.8411 8.71155 19.3605 9.25321C19.8785 9.79363 20.7577 10.1151 22.1898 10.1151V9.81707C20.7894 9.81707 20.0024 9.50131 19.5625 9.04249C19.1238 8.58491 19.0004 7.95391 19.0004 7.24351H18.7147ZM22.1898 10.1151C23.6224 10.1151 24.5014 9.78853 25.0192 9.24571C25.5382 8.70187 25.6648 7.97202 25.6648 7.24351H25.3791C25.3791 7.94385 25.2558 8.57529 24.8168 9.0355C24.3767 9.49675 23.5895 9.81707 22.1898 9.81707V10.1151ZM25.6648 7.24351V0.50469H25.3791V7.24351H25.6648ZM25.522 0.653694H30.3352V0.355687H25.522V0.653694ZM30.1924 0.50469V7.24351H30.4781V0.50469H30.1924ZM35.8875 9.77298H35.7447V9.92198H35.8875V9.77298ZM44.4032 9.77298H44.5461V9.62397H44.4032V9.77298ZM44.4032 14.0209V14.17H44.5461V14.0209H44.4032ZM31.0742 14.0209H30.9314V14.17H31.0742V14.0209ZM31.0742 0.50469V0.355687H30.9314V0.50469H31.0742ZM35.8875 0.50469H36.0304V0.355687H35.8875V0.50469ZM35.8875 9.92198H44.4032V9.62397H35.8875V9.92198ZM44.2604 9.77298V14.0209H44.5461V9.77298H44.2604ZM44.4032 13.8719H31.0742V14.17H44.4032V13.8719ZM31.2171 14.0209V0.50469H30.9314V14.0209H31.2171ZM31.0742 0.653694H35.8875V0.355687H31.0742V0.653694ZM35.7447 0.50469V9.77298H36.0304V0.50469H35.7447ZM52.919 14.065C50.0814 14.065 48.0855 13.502 46.7997 12.3812C45.5195 11.2654 44.9164 9.57269 44.9164 7.24351H44.6307C44.6307 9.6257 45.2492 11.4182 46.6164 12.6099C47.9778 13.7965 50.0547 14.3631 52.919 14.3631V14.065ZM44.9164 7.24351C44.9164 4.92418 45.5194 3.24123 46.7992 2.13266C48.0851 1.01892 50.0812 0.460605 52.919 0.460605V0.162598C50.055 0.162598 47.9782 0.724211 46.6168 1.9034C45.2494 3.08777 44.6307 4.87076 44.6307 7.24351H44.9164ZM52.919 0.460605C55.7471 0.460605 57.7432 1.0236 59.0317 2.13988C60.3141 3.25109 60.9215 4.93431 60.9215 7.24351H61.2072C61.2072 4.87994 60.5837 3.09722 59.2142 1.91066C57.8507 0.729188 55.7741 0.162598 52.919 0.162598V0.460605ZM60.9215 7.24351C60.9215 9.56255 60.314 11.2556 59.0312 12.374C57.743 13.4973 55.7468 14.065 52.919 14.065V14.3631C55.7744 14.3631 57.851 13.7915 59.2145 12.6026C60.5838 11.4088 61.2072 9.61654 61.2072 7.24351H60.9215ZM52.919 10.1151C54.3517 10.1151 55.2305 9.78853 55.7485 9.24571C56.2674 8.70187 56.3941 7.97202 56.3941 7.24351H56.1084C56.1084 7.94385 55.9851 8.57529 55.546 9.0355C55.1058 9.49675 54.3187 9.81707 52.919 9.81707V10.1151ZM56.3941 7.24351C56.3941 6.52519 56.2722 5.80428 55.755 5.26733C55.2391 4.73189 54.3601 4.41056 52.919 4.41056V4.70857C54.3288 4.70857 55.1158 5.02443 55.5534 5.47858C55.9895 5.93122 56.1084 6.55228 56.1084 7.24351H56.3941ZM52.919 4.41056C51.4784 4.41056 50.5992 4.72681 50.0832 5.25984C49.5655 5.79458 49.4438 6.51595 49.4438 7.24351H49.7295C49.7295 6.54221 49.8485 5.92159 50.2842 5.47159C50.7215 5.01987 51.5085 4.70857 52.919 4.70857V4.41056ZM49.4438 7.24351C49.4438 7.98127 49.5704 8.71155 50.0897 9.25321C50.6078 9.79363 51.4868 10.1151 52.919 10.1151V9.81707C51.5187 9.81707 50.7315 9.50131 50.2917 9.04249C49.853 8.58491 49.7295 7.95391 49.7295 7.24351H49.4438Z" fill="black"></path></g><path d="M6.68769 9.75849H15.2034V14.0065H1.87439V0.490208H6.68769V9.75849ZM32.0497 7.22902C32.0497 11.9211 29.5875 14.1996 23.9043 14.1996C18.2024 14.1996 15.7587 11.9404 15.7587 7.22902V0.490208H20.572V7.22902C20.572 8.6772 21.0718 9.95158 23.9043 9.95158C26.7365 9.95158 27.2364 8.65789 27.2364 7.22902V0.490208H32.0497V7.22902ZM37.602 9.75849H46.1177V14.0065H32.7887V0.490208H37.602V9.75849ZM54.6334 14.1996C48.9315 14.1996 46.488 11.9404 46.488 7.22902C46.488 2.53696 48.9315 0.297119 54.6334 0.297119C60.3167 0.297119 62.7788 2.55627 62.7788 7.22902C62.7788 11.9211 60.3167 14.1996 54.6334 14.1996ZM54.6334 9.95158C57.4658 9.95158 57.9657 8.65789 57.9657 7.22902C57.9657 5.81948 57.4843 4.54508 54.6334 4.54508C51.7825 4.54508 51.3011 5.80017 51.3011 7.22902C51.3011 8.6772 51.801 9.95158 54.6334 9.95158Z" fill="black"></path><mask id="mask1_112_15" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="1" y="0" width="62" height="15"><path d="M63 0H1.71429V14.4533H63V0Z" fill="white"></path><path d="M6.68769 9.75849H15.2034V14.0065H1.87439V0.490208H6.68769V9.75849ZM32.0497 7.22902C32.0497 11.9211 29.5875 14.1996 23.9043 14.1996C18.2024 14.1996 15.7587 11.9404 15.7587 7.22902V0.490208H20.572V7.22902C20.572 8.6772 21.0718 9.95158 23.9043 9.95158C26.7365 9.95158 27.2364 8.65789 27.2364 7.22902V0.490208H32.0497V7.22902ZM37.602 9.75849H46.1177V14.0065H32.7887V0.490208H37.602V9.75849ZM54.6334 14.1996C48.9315 14.1996 46.488 11.9404 46.488 7.22902C46.488 2.53696 48.9315 0.297119 54.6334 0.297119C60.3167 0.297119 62.7788 2.55627 62.7788 7.22902C62.7788 11.9211 60.3167 14.1996 54.6334 14.1996ZM54.6334 9.95158C57.4658 9.95158 57.9657 8.65789 57.9657 7.22902C57.9657 5.81948 57.4843 4.54508 54.6334 4.54508C51.7825 4.54508 51.3011 5.80017 51.3011 7.22902C51.3011 8.6772 51.801 9.95158 54.6334 9.95158Z" fill="black"></path></mask><g mask="url(#mask1_112_15)"><path d="M6.68754 9.75832H6.54468V9.90733H6.68754V9.75832ZM15.2033 9.75832H15.3461V9.60932H15.2033V9.75832ZM15.2033 14.0063V14.1553H15.3461V14.0063H15.2033ZM1.87424 14.0063H1.73138V14.1553H1.87424V14.0063ZM1.87424 0.490042V0.341038H1.73138V0.490042H1.87424ZM6.68754 0.490042H6.8304V0.341038H6.68754V0.490042ZM6.68754 9.90733H15.2033V9.60932H6.68754V9.90733ZM15.0604 9.75832V14.0063H15.3461V9.75832H15.0604ZM15.2033 13.8573H1.87424V14.1553H15.2033V13.8573ZM2.0171 14.0063V0.490042H1.73138V14.0063H2.0171ZM1.87424 0.639046H6.68754V0.341038H1.87424V0.639046ZM6.54468 0.490042V9.75832H6.8304V0.490042H6.54468ZM15.7585 0.490042V0.341038H15.6157V0.490042H15.7585ZM20.5718 0.490042H20.7147V0.341038H20.5718V0.490042ZM27.2363 0.490042V0.341038H27.0934V0.490042H27.2363ZM32.0495 0.490042H32.1924V0.341038H32.0495V0.490042ZM31.9067 7.22885C31.9067 9.5479 31.2991 11.2409 30.0164 12.3593C28.7281 13.4827 26.732 14.0504 23.9041 14.0504V14.3484C26.7594 14.3484 28.8361 13.7769 30.1997 12.588C31.5688 11.3941 32.1924 9.60188 32.1924 7.22885H31.9067ZM23.9041 14.0504C21.0665 14.0504 19.0705 13.4873 17.7847 12.3666C16.5047 11.2508 15.9014 9.55805 15.9014 7.22885H15.6157C15.6157 9.61106 16.2344 11.4036 17.6015 12.5952C18.963 13.7819 21.0398 14.3484 23.9041 14.3484V14.0504ZM15.9014 7.22885V0.490042H15.6157V7.22885H15.9014ZM15.7585 0.639046H20.5718V0.341038H15.7585V0.639046ZM20.429 0.490042V7.22885H20.7147V0.490042H20.429ZM20.429 7.22885C20.429 7.96663 20.5554 8.6969 21.0748 9.23857C21.5928 9.77897 22.472 10.1004 23.9041 10.1004V9.80241C22.5037 9.80241 21.7167 9.48666 21.2768 9.02785C20.8381 8.57027 20.7147 7.93927 20.7147 7.22885H20.429ZM23.9041 10.1004C25.3367 10.1004 26.2157 9.77389 26.7335 9.23107C27.2525 8.68721 27.3791 7.95738 27.3791 7.22885H27.0934C27.0934 7.9292 26.9701 8.56065 26.5311 9.02086C26.091 9.4821 25.3038 9.80241 23.9041 9.80241V10.1004ZM27.3791 7.22885V0.490042H27.0934V7.22885H27.3791ZM27.2363 0.639046H32.0495V0.341038H27.2363V0.639046ZM31.9067 0.490042V7.22885H32.1924V0.490042H31.9067ZM37.6018 9.75832H37.459V9.90733H37.6018V9.75832ZM46.1175 9.75832H46.2604V9.60932H46.1175V9.75832ZM46.1175 14.0063V14.1553H46.2604V14.0063H46.1175ZM32.7885 14.0063H32.6457V14.1553H32.7885V14.0063ZM32.7885 0.490042V0.341038H32.6457V0.490042H32.7885ZM37.6018 0.490042H37.7447V0.341038H37.6018V0.490042ZM37.6018 9.90733H46.1175V9.60932H37.6018V9.90733ZM45.9747 9.75832V14.0063H46.2604V9.75832H45.9747ZM46.1175 13.8573H32.7885V14.1553H46.1175V13.8573ZM32.9314 14.0063V0.490042H32.6457V14.0063H32.9314ZM32.7885 0.639046H37.6018V0.341038H32.7885V0.639046ZM37.459 0.490042V9.75832H37.7447V0.490042H37.459ZM54.6333 14.0504C51.7957 14.0504 49.7998 13.4873 48.514 12.3666C47.2338 11.2508 46.6307 9.55805 46.6307 7.22885H46.345C46.345 9.61106 46.9635 11.4036 48.3307 12.5952C49.6921 13.7819 51.769 14.3484 54.6333 14.3484V14.0504ZM46.6307 7.22885C46.6307 4.90952 47.2337 3.22657 48.5135 2.11802C49.7994 1.00426 51.7955 0.445956 54.6333 0.445956V0.147949C51.7692 0.147949 49.6925 0.709563 48.3311 1.88875C46.9637 3.07312 46.345 4.85612 46.345 7.22885H46.6307ZM54.6333 0.445956C57.4614 0.445956 59.4575 1.00894 60.746 2.12523C62.0284 3.23644 62.6358 4.91967 62.6358 7.22885H62.9215C62.9215 4.86528 62.298 3.08256 60.9285 1.896C59.565 0.714538 57.4884 0.147949 54.6333 0.147949V0.445956ZM62.6358 7.22885C62.6358 9.5479 62.0283 11.2409 60.7455 12.3593C59.4573 13.4827 57.4611 14.0504 54.6333 14.0504V14.3484C57.4887 14.3484 59.5653 13.7769 60.9288 12.588C62.2981 11.3941 62.9215 9.60188 62.9215 7.22885H62.6358ZM54.6333 10.1004C56.066 10.1004 56.9448 9.77389 57.4628 9.23107C57.9817 8.68721 58.1084 7.95738 58.1084 7.22885H57.8227C57.8227 7.9292 57.6994 8.56065 57.2603 9.02086C56.8201 9.4821 56.033 9.80241 54.6333 9.80241V10.1004ZM58.1084 7.22885C58.1084 6.51054 57.9865 5.78963 57.4693 5.25269C56.9534 4.71725 56.0744 4.39591 54.6333 4.39591V4.69392C56.0431 4.69392 56.8301 5.00979 57.2677 5.46392C57.7038 5.91656 57.8227 6.53763 57.8227 7.22885H58.1084ZM54.6333 4.39591C53.1927 4.39591 52.3135 4.71215 51.7975 5.24518C51.2798 5.77994 51.1581 6.5013 51.1581 7.22885H51.4438C51.4438 6.52755 51.5628 5.90694 51.9985 5.45693C52.4358 5.00521 53.2228 4.69392 54.6333 4.69392V4.39591ZM51.1581 7.22885C51.1581 7.96663 51.2847 8.6969 51.804 9.23857C52.3221 9.77897 53.2011 10.1004 54.6333 10.1004V9.80241C53.233 9.80241 52.4458 9.48666 52.006 9.02785C51.5672 8.57027 51.4438 7.93927 51.4438 7.22885H51.1581Z" fill="black"></path></g></svg>
                </a>
                </div>
<!--                <div>
                    <h4>Sort By</h4>
                    <b-form-select v-model="sortBy" :options="sortOptions"></b-form-select>
                </div>
                <div>
                    <h4>Sort Direction</h4>
                    <b-form-select v-model="sortDesc" :options="sortDirectionOptions"></b-form-select>
                </div>-->
                <!--            <h4>Find By Tag</h4>
                            <el-select v-model="selectedFlags" multiple filterable placeholder="Please select">
                                <el-option
                                        v-for="item in flags"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>-->
            </div>
        </div>
    </div>
    <el-table
        :data="filteredPools"

        style="width: 100%"
        :row-key="(row) => (row.protocol + row.symbol)"
        :expand-row-keys="expandedRows"
    >
        <el-table-column
            prop="name"
            label="Name"
            sortable
        >
            <template #default="scope">
                <img :src="scope.row.token.logoURI" class="brround" style="width: 25px; height: 25px;" v-if="scope.row.token">
                {{ scope.row.symbol }}
                <div class="small">{{ scope.row.name }}</div>
            </template>
        </el-table-column>

        <el-table-column
            prop="lending_rate"
            label="Best Lending Rate"
            sortable
        >
            <template #default="scope">
                {{ Number(scope.row.lending_rate).toFixed(2) }}%
            </template>
        </el-table-column>

        <el-table-column
            prop="borrow_rate"
            label="Best Borrow Rate"
            sortable
        >
            <template #default="scope">
                {{ Number(scope.row.borrow_rate).toFixed(2) }}%
            </template>
        </el-table-column>

        <el-table-column
            prop="deposits"
            label="Deposits (USDC)"
            sortable
        >
            <template #default="scope">
                ${{ Math.floor(scope.row.deposits).toLocaleString() }}
            </template>
        </el-table-column>

        <el-table-column
            prop="details"
            label="Details"
        >
            <template #default="scope">
                <el-button type="success" @click="toggleExpand(scope.row)">Compare Rates</el-button>
            </template>
        </el-table-column>

        <el-table-column type="expand">

            <template #default="scope">
                <el-table
                    :data="scope.row.pools"
                    style="width: 100%"
                >
                    <el-table-column
                        prop="protocol"
                        label="Platform"
                        sortable
                    />
                    <el-table-column
                        prop="lending_rate"
                        label="Lending Rate"
                        sortable
                    >
                        <template #default="scope">
                            {{ Number(scope.row.lending_rate).toFixed(2) }}%
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="borrow_rate"
                        label="Borrow Rate"
                        sortable
                    >
                        <template #default="scope">
                            {{ Number(scope.row.borrow_rate).toFixed(2) }}%
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="total_deposits_usd"
                        label="Total Deposits (USD)"
                        sortable
                    >
                        <template #default="scope">
                            ${{ Math.floor(scope.row.total_deposits_usd).toLocaleString() }}
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="total_borrows_usd"
                        label="Total Borrows (USD)"
                        sortable
                    >
                        <template #default="scope">
                            ${{ Math.floor(scope.row.total_borrows_usd).toLocaleString() }}
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="borrow_pool_pct"
                        label="Utilization Rate"
                        sortable
                    >
                        <template #default="scope">
                            {{ Number(scope.row.borrow_pool_pct).toFixed(2) }}%
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="link"
                        label="Details"
                    >
                        <template #default="scope">
                            <a :href="scope.row.link" target="_blank" class="btn btn-success">Visit</a>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
        </el-table-column>
    </el-table>

    <el-pagination
        v-model:currentPage="currentPage"
        :total="filteredPools.length"
        :pageSize="perPage"
        class="my-0"
        aria-controls="my-table"
    />
</div>
</template>

<script>
export default {
    name: "BorrowLend",
    props: {
        pools: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            perPage: 50,
            currentPage: 1,
            sortBy: 'volume',
            sortDesc: true,
            sortByDetails: 'volume_24h',
            sortDetailsDesc: true,
            searchText:'',
            // pools: [],
            selectedTags: [],
            flags: [
                /*  'excessive_commission', //danger
        'zero_commission',
        'low_software_version',
        'low_published_information',
        'high_stake_concentration',
        'high_data_center_concentration',
        'extreme_data_center_concentration',
        'delinquent',
        "SLOW_VOTER",
        "BLACKLIST_COMMISSION_RUG",
        'high_commission' // warning
        */

            ],
            links: {
                'kamino': 'https://app.kamino.finance/?utm_campaign=Solana+Compass&utm_source=Solana+Compass',
                'marginfi': 'https://www.mfi.gg/refer/cd1e0ff4-f8f0-4489-bdac-4fc41db3f78f',
                'mango': 'https://app.mango.markets/stats?utm_campaign=Solana+Compass&utm_source=Solana+Compass',
                'solend': 'https://solend.fi/dashboard/',
                'drift': 'https://app.drift.trade/ref/compass?utm_campaign=Solana+Compass&utm_source=Solana+Compass',
                'lulo': 'https://lulo.fi/?utm_campaign=Solana+Compass&utm_source=Solana+Compass',

            },

            sortOptions: [
                {value: 'name', text: 'Name'},
                {value: 'max', text: 'Yield'},
                {value: 'tvl', text: 'TVL'},
                {value: 'volume', text: 'Volume'},
                {value: 'fees', text: 'Fees'},
                {value: 'volume', text: '# of Pools'},

            ],
            sortDirectionOptions: [
                {value: true, text: 'Descending'},
                {value: false, text: 'Ascending'},
            ],
            expandedRows:[],
        }
    },
    mounted() {
        // this.getPools()
    },
    computed: {
        filteredPools() {
            let filteredPools = this.pools
            if (this.searchText) {
                filteredPools = filteredPools.filter(validator => {
                    let name = (validator.name || '').toLowerCase() + ' ' + (validator.symbol || '').toLowerCase()
                    return name.toLowerCase().includes(this.searchText.toLowerCase())
                })

            }
            return filteredPools.map((pool, index) => {
               pool._showDetails=false
                return pool
            })
        }
    },
    methods: {
        onSortChange({ sortBy, sortDesc }) {
            this.sortBy = sortBy
            this.sortDesc = sortDesc
        },
        async getPools() {
            this.pools = (await axios.get('/defi/pools')).data
            console.log(this.pools)
        },
        getlinks(item) {
            console.log(item.name, this.links[item.name])
            return this.links[item.name]
        },
        toggleExpand(row) {
            let rowId = row.protocol + row.symbol
            if (this.expandedRows.includes(rowId)) {
                this.expandedRows = this.expandedRows.filter((id) => id !== rowId);
            } else {
                this.expandedRows.push(rowId);
            }
        },
    }
}
</script>

<style scoped>

</style>
